import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { ConvertHelper } from '../../../helpers';
import { Warning } from './abc-core-error-handling.errortypes';

export class ErrorInfo {
  constructor(public readonly message: string, public readonly details: string, public readonly isWarning?: boolean) {}

  public getFullMessage(enforceDetails: boolean = false): string {
    let fullMessage: string = this.message;

    if (this.details && (enforceDetails || isDevMode())) {
      fullMessage = `${fullMessage}\n\nDetails (only in Dev mode):\n\n${this.details}`;
    }

    return fullMessage;
  }
}

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingService {
  public publish(error: any): void {
    const allMessages = this.getErrorInfo(error);

    let message: string = allMessages.message;

    if (allMessages.details && isDevMode()) {
      message = `${message}\n\nDetails (only in Dev mode, also copied to clipboard (if supported)):\n\n${allMessages.details}`;
      this.copyToClipboard(message);
    }

    console.log(error);
    alert(message);

    // let errorMessage = error;
    // if (error.error instanceof ErrorEvent) {
    //     // Client-side errors
    //     errorMessage = `Error: ${error.error.message}`;
    // } else {
    //     // Server-side errors
    //     errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    // }
    // window.alert(errorMessage);
    // return throwError(errorMessage);
  }

  public getErrorInfo(err: any): ErrorInfo {
    let message: string = null;
    let details: string = null;
    let isWarning: boolean;

    if (err) {
      if (err.name == Warning.identifier) {
        isWarning = true;
      }
      if (err instanceof HttpErrorResponse) {
        if (err.error) {
          message = err.error.ExceptionMessage || err.error.Message || err.message;
          details = this.unpackStackTrace(err.error);
          const modelState = err.error.ModelState;
          if (modelState && modelState['']) {
            message = modelState[''] + '\n' + message;
          }
        } else {
          message = err.message;
          details = 'No inner error provided.';
        }
      } else if (err instanceof Error) {
        message = err.message;

        if (err.stack) {
          details = err.stack;
        } else {
          details = 'No error stack provided.';
        }
      } else if (err.message) {
        message = ConvertHelper.toString(err.message);
        details = ConvertHelper.toString(err, 4);
      }
    }

    if (!message) {
      message = 'Ein unbekannter Fehler ist aufgetreten!';
      details = ConvertHelper.toString(err, 4);
    }

    if (details) {
      details = details.replace(/\\r\\n/g, '\n');
      details = details.trim();
    }

    return new ErrorInfo(message, details, isWarning);
  }

  private unpackStackTrace(err: any): string {
    let fullStackTrace: string = ConvertHelper.toString(err.StackTrace, 4) || ConvertHelper.toString(err, 4);
    if (err.InnerException) {
      fullStackTrace = this.unpackStackTrace(err.InnerException) + '\n' + fullStackTrace;
    }
    return fullStackTrace;
  }

  public getFullErrorMessage(err: any, enforceDetails: boolean = false): string {
    return this.getErrorInfo(err).getFullMessage(enforceDetails);
  }

  private copyToClipboard(text: string) {
    const handler = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', text);
      e.preventDefault();
      document.removeEventListener('copy', handler);
    };

    document.addEventListener('copy', handler);
    document.execCommand('copy');
  }
}
